import {Pipe, PipeTransform} from '@angular/core';
import {PersonAdresseListEntryMeta, PersonStammVersionDetailEntryMeta} from "../../../core/gb-api";
import {TranslateNamePipe} from "../simple/translate-name.pipe";
import {ZentralePersonDetailEntryMeta} from 'app/core/personstamm-api';

@Pipe({
  name: 'formatPersonstammAdress'
})
export class FormatPersonstammAddressPipe implements PipeTransform {

  constructor(private tranlateName: TranslateNamePipe) {
  }


  private notEmpty = val => val;

  transform(entry: PersonStammVersionDetailEntryMeta | ZentralePersonDetailEntryMeta, adress: PersonAdresseListEntryMeta): string {
    let value = "";

    const separator = " ";
    const newLine = "\n";
    const landSeparator = "-";

    if (entry) {
      const anrede = entry.anrede && entry.anrede.text ? this.tranlateName.transform(entry.anrede.text) : '';
      const name = [entry.vorname, entry.name].filter(this.notEmpty).join(separator);
      value = [anrede, name].filter(this.notEmpty).join(newLine);
    }

    if (adress) {
      const strasse = [adress.strasse, adress.hausnummer].filter(this.notEmpty).join(separator);
      const ort = [adress.plz, adress.ort].filter(this.notEmpty).join(separator);
      const landZusatz = [adress.landCode ? adress.landCode.toUpperCase() : null, ort].filter(this.notEmpty).join(landSeparator);
      value = [value, strasse, landZusatz].filter(this.notEmpty).join(newLine);
    }

    return value;
  }

}
